<app-drag-handle />

<div class="passport-add-stamp">
  <div class="passport-add-stamp__header">
    <h6 class="ci-heading-h6-semibold">
      {{ addedBadge()?.title?.[translate.currentLang] }}
    </h6>
    <ci-icon (click)="dismissBottomSheet()" name="close" scale="2x" />
  </div>

  <div class="passport-add-stamp__body">
    @if(!addedBadge()){
      <div class="passport-add-stamp__body__image">
        @if(!isStamping()){
          <ci-icon name="atencion-turistica-canales" scale="3x"></ci-icon>
        }
        @else {
          <zxing-scanner [device]="currentDevice" (scanSuccess)="onCodeResult($event)" />
        }
      </div>
    }

    @if(addedBadge()){
      @if(addedBadge()?.image?.[translate.currentLang]){
        <img [src]="addedBadge().image[translate.currentLang]" />
      }
      <div class="passport-add-stamp__body__info">
        <p class="ci-heading-h6-s-semibold congrats">{{ '¡Enhorabuena!' | translate }}</p>
        <span class="ci-paragraph-p1-regular">{{ ('Se ha registrado tu visita' | translate)}}</span>
        <span class="ci-paragraph-p1-regular stamp">
          {{ addedBadge()?.interest_point?.title?.[translate.currentLang] }}
        </span>
      </div>

      @if(addedBadge()?.descriptions?.[0]?.[translate.currentLang]){
        <div @fadeIn class="passport-add-stamp__body__content">
          <ci-scroll-fade height="200px">
            @for(description of addedBadge()?.descriptions; track $index) {
              <p class="ci-paragraph-p1-regular" [innerHTML]="description?.[translate.currentLang]"></p>
              @if (addedBadge()?.descriptions?.length > 1 && $index === 0){
                <br>
              }
            }
          </ci-scroll-fade>
        </div>
        }
    }

    <div class="passport-add-stamp__body__action-buttons">
      @if(!isStamping()) {
        <ci-button 
          (click)="toggleStamp()" 
          class-name="ci-btn-primary-m-filled" 
          type="button" 
        >
          {{ 'Sellar ahora' | translate }}
        </ci-button>
      } @else if(!addedBadge()){
        <ci-button 
          @fadeOut 
          class-name="ci-btn-primary-m-filled" 
          icon-name="loader-debounce" 
          type="button" 
          [attr.aria-label]="'Sellando...' | translate"
        >
          {{ 'Sellando...' | translate }}
        </ci-button>
      }
    
      @if(addedBadge()) {
        <ci-button
          (click)="navigateToBadgeListByPassportId(addedBadge()?.passport.id)" 
          class-name="ci-btn-primary-m-outlined" 
          type="button" 
          [aria-label]="'Ver pasaporte' | translate" 
        >
          {{ 'Ver pasaporte' | translate }}
        </ci-button>
      } @else {
        <ci-button
          (click)="navigateToPassportsList()" 
          class-name="ci-btn-primary-m-outlined" 
          type="button" 
          [aria-label]="'Mis pasaportes' | translate" 
        >
          {{ 'Mis pasaportes' | translate }}
        </ci-button>
      }
    </div>
  </div>
</div>